import React, { useEffect, useState } from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse, Modal } from "antd";
import { FormatDateTime } from "../../../utility/format";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { BadgePill } from "../../../badge_pill/badge_pill";
import ApproveProcessLogModal from "../../../approve_process/approve_process_log_modal";
import ApproveProcessModal from "../../../approve_process/approve_process_modal";
import DynamicLabelGroup from "../../../dynamic_label/dynamic_label_group";

import { connect } from "react-redux";
import Cookies from "js-cookie";
const { Panel } = Collapse;

function CheckAlarm({
  title,
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  Jobdata,
  language,
  factupdate,
}) {
  const locale = Cookies.get("locale");
  const [DataAlarms, setDataAlarms] = useState([]);
  const [showApproveProcessLog, setshowApproveProcessLog] = useState(false);
  const [showApprove, setshowApprove] = useState(false);
  const [showApprveDes, setshowApprveDes] = useState(false);
  const [sendData, setsendData] = useState(null);
  useEffect(() => {
    Api.post("job_detail/get_AlarmNetwork_List", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: headerdata.job_id,
    }).then((res) => {
      if (res?.data.result?.code === "P") {
        setDataAlarms(res.data.data.alarmNetwork);
      }
    });
  }, [headerdata.job_id]);

  const openViewLogModal = (item) => {
    setsendData(item);
    setshowApproveProcessLog(true);
  };
  const openViewApprove = (item) => {
    setsendData(item);
    setshowApprove(true);
  };
  const openApproveDes = (item) => {
    setshowApprveDes(true);
    console.log(item);
    setsendData(item);
  };
  const approveLogCallBack = () => {
    setshowApproveProcessLog(false);
  };
  const approveFormCallBack = () => {
    setshowApprove(false);
    window.location.reload();
  };
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <div className="font-thai-b fs-18">
              <img
                src={Api.absoluteUrl(`/icon/alert.svg`)}
                alt={title}
                className="mr-2 mb-1"
              />
              <span className="c-blue text-uppercase">{title}</span>
            </div>
          }
          key="1"
          className="font-thai-r fs-18 my-0"
        >
          {DataAlarms?.map((data, index) => {
            let h5_color = "c-blue";
            if (data.oper_job_alarm_network_type_id === 1) {
              h5_color = "c-green";
            }
            if (data.oper_job_alarm_network_type_id === 2) {
              h5_color = "c-red";
            }
            return (
              <div key={`alarm_clear_${index}`} className="card mb-2">
                <div className="card-body px-1 py-1">
                  <h5 className={`${h5_color} pl-2`}>
                    <i className="fa fa-circle fa-xs mr-2"></i>
                    {data.alarm_network_type_name}
                  </h5>
                  <div className="card-text">
                    <div className="col-12">
                      <span className="pl-0 pr-1">{`Date/time`} :</span>
                      <span className="">
                        <FormatDateTime
                          text={data.oper_job_alarm_network_datetime}
                        ></FormatDateTime>
                      </span>
                    </div>
                    <div className="col-12">
                      <span className="pl-0 pr-1">{`หมายเหตุ`} :</span>
                      <span className="">
                        {data.oper_job_alarm_network_type_desc ?? "-"}
                      </span>
                    </div>
                    {data.approve_status_id ? (
                      <>
                        <div className="col-12">
                          <span className="pl-0 pr-1">
                            {factupdate
                              ? language[locale]["approve_status"]
                              : `Status`}
                          </span>
                          <span className="col col-8 content-text">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                openApproveDes(data?.approve_config_desc)
                              }
                            >
                              <BadgePill
                                bgColor={data.approve_status_bgcolor}
                                color={data.approve_status_color}
                                text={`${data.approve_status_name} Level: ${data.last_approve_level_seq}`}
                              ></BadgePill>
                            </span>
                            <Renderbtn
                              renderBtn={{
                                visible: true,
                                html_tag: "button",
                                type: "FA",
                                font_awasome: "fas fa-history",
                                css: "btn btn-xs btn-light",
                              }}
                              btnMiddleware={openViewLogModal}
                              index="view_btn_stoptime"
                              item={{
                                approve_id: data.approve_id,
                              }}
                              disable={false}
                            ></Renderbtn>
                            {Number(data.approve_status_id) > 2 ? (
                              <Renderbtn
                                renderBtn={{
                                  visible: true,
                                  html_tag: "button",
                                  type: "FA",
                                  font_awasome: "far fa-check-square",
                                  css: "btn btn-xs btn-light",
                                }}
                                btnMiddleware={openViewApprove}
                                index="view_btn_stoptime"
                                item={{
                                  approve_id: data.approve_id,
                                  last_approve_level_seq:
                                    data.last_approve_level_seq,
                                  job_id: data.job_id,
                                  data_dynamic: data.data_dynamic,
                                }}
                                disable={false}
                              ></Renderbtn>
                            ) : null}
                          </span>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            );
          })}
          {DataAlarms && DataAlarms.length === 0 ? (
            <>
              <div className="row justify-content-center">
                <span>ไม่พบข้อมูล Alarm Network</span>
              </div>
            </>
          ) : null}
        </Panel>
      </Collapse>

      {showApproveProcessLog ? (
        <ApproveProcessLogModal
          visible={showApproveProcessLog}
          callbackFunction={approveLogCallBack}
          wrapClassName="bbtec-theme"
          sendData={sendData ? sendData : null}
        ></ApproveProcessLogModal>
      ) : null}
      {showApprove ? (
        <ApproveProcessModal
          visible={showApprove}
          callbackFunction={approveFormCallBack}
          sendData={sendData ? { ...sendData, mode: "alarm" } : null}
          mode={"alarm"}
        ></ApproveProcessModal>
      ) : null}
      {showApprveDes ? (
        <Modal
          title={<h4>Approve Description</h4>}
          footer={null}
          visible={showApprveDes}
          wrapClassName={"bbtec-theme"}
          onCancel={() => setshowApprveDes(false)}
        >
          <DynamicLabelGroup
            data={sendData ? sendData : null}
            groupHeader={false}
            language={language}
            factupdate={factupdate}
            locale={locale}
            wrapClassname={"bbtec-theme"}
          ></DynamicLabelGroup>
        </Modal>
      ) : null}
    </>
  );
}
const mapStateToProps = (state) => ({
  language: state.masterLang.masterLang,
  factupdate: state.masterLang.factUpdate,
});
export default connect(mapStateToProps)(CheckAlarm);
